import clsx from "clsx";
import React from "react";
import Rail from "web/react/components/LEGACY_rail/rail";
import AjaxRelatedSearchProductImages from "web/react/components/related-searches-rail/ajax-related-search-product-images";
import analytics from "web/script/analytics/analytics";
import styles from "./related-designers-rail.module.css";

interface RelatedDesignersRailProps {
    title?: string;
    designers: any[];
    features: any;
    eventCategory?: string;
    className?: string;
    showImages?: boolean;
}

function RelatedDesignersRail({
    title,
    designers,
    features,
    eventCategory,
    className,
    showImages = true,
}: RelatedDesignersRailProps): JSX.Element {
    function handleClick(): void {
        if (eventCategory) {
            analytics.event(eventCategory, "pdp_related_click", "related_designer_clicked");
        }
    }

    return (
        <Rail
            title={title}
            analyticsLabel={"related_designers"}
            className={clsx(className, styles.railWrapper)}
            peekingCard={features.uj_peeking_card}
        >
            {designers.map((designer) => (
                <div key={designer.url} className={styles.cardWrapper}>
                    <div className={styles.designerCard}>
                        {showImages && (
                            <div onClick={handleClick}>
                                <AjaxRelatedSearchProductImages feedUrl={designer.url} />
                            </div>
                        )}
                        <a
                            href={designer.url}
                            className={styles.designerName}
                            onClick={handleClick}
                        >
                            {designer.name}
                        </a>
                    </div>
                </div>
            ))}
        </Rail>
    );
}

export default RelatedDesignersRail;
